export const getResponsiveModalWidth = () => {
  if (window.innerWidth > 1200) {
    return "682px";
  } else if (window.innerWidth > 900) {
    return "80%";
  } else if (window.innerWidth > 600) {
    return "90%";
  } else {
    return "97%";
  }
};

export const getResponsiveDocumentModalWidth = () => {
  if (window.innerWidth > 1200) {
    return "400px";
  } else if (window.innerWidth > 900) {
    return "55%";
  } else if (window.innerWidth > 600) {
    return "70%";
  } else {
    return "97%";
  }
};

export const numberWithCommas = (n = 0) => {
  const numberFormatter = Intl.NumberFormat("en-US");
  return numberFormatter.format(n);
};

export const monthsToYears = (monthCount = 0) => {
  const getPlural = (number, word) => {
    return (number === 1 && word.one) || word.other;
  };

  var months = { one: "month", other: "months" },
    years = { one: "year", other: "years" },
    m = monthCount % 12,
    y = Math.floor(monthCount / 12),
    result = [];

  y && result.push(y + " " + getPlural(y, years));
  m && result.push(m + " " + getPlural(m, months));
  return result.join(", ");
};

export const extractDocName = (url) => {
  const splitedLink = url?.split(".com/uploads/files/")[1];
  return splitedLink;
};

export const extractDocType = (url) => {
  const splitedLink = url
    ?.split("")
    .reverse()
    .join("")
    .split(".")[0]
    .split("")
    .reverse()
    .join("");
  return splitedLink;
};

export const cutText = (name, chars, from) => {
  if (!name) {
    return;
  } else {
    if (name.length > chars) {
      if (from === "start") {
        return name.length > chars ? name.substr(0, chars) : name;
      } else if (from === "end") {
        return name.length > chars ? name.substr(chars) : name;
      } else {
        return name.length > chars ? name.substr(0, chars) : name;
      }
    } else {
      return name;
    }
  }
};

export const parseData = (_data) => {

  if(_data){
    const data = JSON.parse(_data);

    return data;
  }

};


export const dataURLtoFile=(dataurl, filename)=> {
 
  var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]), 
      n = bstr.length, 
      u8arr = new Uint8Array(n);
      
  while(n--){
      u8arr[n] = bstr.charCodeAt(n);
  }
  
  return new File([u8arr], filename, {type:mime});
}


export const convertToLocaleString=(string)=>{
  return string?.toLocaleString()
}

export function removeUnderscore(str) {
  return str.replace(/_/g, ' ');
}